import { LOGOUT, SET_SETTINGS } from "../actions/types";

const INITIAL_STATE = {
    minCarry: null,
    maxCarry: null,
    carryThreshold: null
};

const settingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SETTINGS:
            return {
                ...state,
                minCarry: action.payload.minCarry,
                maxCarry: action.payload.maxCarry,
                carryThreshold: action.payload.carryThreshold
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
           return state;
    }
};

export default settingsReducer;